import{styled as e}from"styled-components";const n=e.textarea`
  font: 1em Consolas;
  height: auto;
  line-height: normal;
  max-width: 550px;
  margin: 0px;
  border: none;
  white-space: pre-wrap;
  background: none;
  outline: none;
  vertical-align: middle;
`;export{n as BaseTextArea};
